<template>
  <nav class="navbar" :class="{ 'navbar-scrolled': isScrolled }">
    <div class="navbar-container">
      <div class="navbar-brand" @click="$router.push('/')">
        <img src="/logo/logo.png" alt="北京拓问律师事务所 Logo" class="navbar-logo" />
        <h1>北京拓问律师事务所</h1>
      </div>
      <div class="navbar-menu" :class="{ 'active': menuOpen }">
        <router-link 
          v-for="item in menuItems" 
          :key="item.path"
          :to="item.path"
          class="navbar-item"
          @click="closeMenu"
        >
          {{ item.name }}
        </router-link>
        <div class="language-switcher">
          <span :class="{ active: currentLang === 'zh' }" @click="switchLang('zh')">中文</span>
          <span>/</span>
          <span :class="{ active: currentLang === 'en' }" @click="switchLang('en')">EN</span>
        </div>
      </div>
      <div class="navbar-toggle" @click="toggleMenu">
        <el-icon><Menu /></el-icon>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { Menu } from '@element-plus/icons-vue'

export default {
  name: 'NavBar',
  components: {
    Menu
  },
  setup() {
    const isScrolled = ref(false)
    const menuOpen = ref(false)
    const currentLang = ref('zh')
    
    const menuItems = [
      { name: '首页', path: '/' },
      { name: '关于我们', path: '/about' },
      { name: '专业领域', path: '/practice-areas' },
      { name: '专业人员', path: '/professionals' },
      { name: '新闻动态', path: '/news' },
      { name: '联系我们', path: '/contact' }
    ]
    
    const handleScroll = () => {
      isScrolled.value = window.scrollY > 50
    }
    
    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value
    }
    
    const closeMenu = () => {
      menuOpen.value = false
    }
    
    const switchLang = (lang) => {
      currentLang.value = lang
      // 这里可以添加语言切换逻辑
    }
    
    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })
    
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })
    
    return {
      isScrolled,
      menuOpen,
      currentLang,
      menuItems,
      toggleMenu,
      closeMenu,
      switchLang
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
}

.navbar-scrolled {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.15);
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.navbar-brand {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
}

.navbar-logo {
  height: 60px;
  width: auto;
  object-fit: contain;
  flex: 0 0 auto;
  filter: drop-shadow(0 0 1px rgba(0,0,0,0.1));
}

.navbar-brand h1 {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.navbar-menu {
  display: flex;
  align-items: center;
  gap: 30px;
}

.navbar-item {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
}

.navbar-item:hover,
.navbar-item.router-link-active {
  color: #667eea;
}

.navbar-item.router-link-active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  border-radius: 1px;
}

.navbar-item::before {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%) scaleX(0);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #667eea, #764ba2);
  transition: width 0.3s ease, transform 0.3s ease;
  border-radius: 1px;
}

.navbar-item:hover::before {
  width: 100%;
  transform: translateX(-50%) scaleX(1);
}

.language-switcher {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid #e0e0e0;
}

.language-switcher span {
  cursor: pointer;
  color: #666;
  font-size: 14px;
  transition: color 0.3s;
}

.language-switcher span.active {
  color: #667eea;
  font-weight: 600;
}

.navbar-toggle {
  display: none;
  cursor: pointer;
  font-size: 24px;
  color: #333;
}

@media (max-width: 768px) {
  .navbar-toggle {
    display: block;
  }
  
  .navbar-menu {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    padding: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transform: translateY(-100%);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }
  
  .navbar-menu.active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }
  
  .language-switcher {
    border-left: none;
    padding-left: 0;
    margin-left: 0;
  }
}
</style>

